<script>
    import { mapGetters } from 'vuex'

    export default {
        render() {
            return this.$scopedSlots.default({
                beforeTermsText: this.termsParts[0],
                termsLinkText: this.termsParts[1],
                betweenTermsAndPrivacyText: this.termsParts[2],
                privacyLinkText: this.termsParts[3],
                afterPrivacyText: this.termsParts[4],
            });
        },

        computed: {
             ...mapGetters('general', ['_']),

            termsText() {
                return this._('register_form_v3.form.terms_optin');
            },

            termsParts() {
                return [
                    this.termsText.replace(/\{terms_link_open\}.*/, ''),
                    this.termsText.replace(/.*\{terms_link_open\}/, '').replace(/\{terms_link_close\}.*/, ''),
                    this.termsText.replace(/.*\{terms_link_close\}/, '').replace(/\{privacy_link_open\}.*/, ''),
                    this.termsText.replace(/.*\{privacy_link_open\}/, '').replace(/\{privacy_link_close\}.*/, ''),
                    this.termsText.replace(/.*\{privacy_link_close\}/, ''),
                ]
            }
        }

    }
</script>
